const mReturnTo = {
  mReturnTo: {
    message: 'Espera un momento...'
  }
}

export default mReturnTo
